module.exports = __webpack_public_path__ + "static/media/kubernetes.efa8fbd9.svg";